<template>
    <div class="e-commerce-wrap">
       <div class="top-wrap">
           <div class="text-wrap">
               <div class="title">电子商务解决方案</div>
               <div class="sub-title">电子商务解决方案通过建设垂直电商平台实现商品、订单、购物车、用户、支付、搜索、互动等电商功能。本方案在电子图书出版领域得到规模化商用，为客户实现了线上网上书城、线上线下结合的书店业务等。</div>
           </div>
           <img src="../assets/banner_img1.png" alt="">
       </div>
       <div class="business-title">业务能力</div>
       <div class="business-list-wrap">
        <el-row :gutter="10">
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[0].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[0].title}}</div>
                    <div class="content">{{solutions[0].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[1].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[1].title}}</div>
                    <div class="content">{{solutions[1].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[2].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[2].title}}</div>
                    <div class="content">{{solutions[2].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[3].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[3].title}}</div>
                    <div class="content">{{solutions[3].content}}</div>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[4].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[4].title}}</div>
                    <div class="content">{{solutions[4].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[5].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[5].title}}</div>
                    <div class="content">{{solutions[5].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[6].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[6].title}}</div>
                    <div class="content">{{solutions[6].content}}</div>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="border">
                    <div class="border_img_parent">
                        <img :src="solutions[7].img" class="solu_img_border"/>
                    </div>
                    <div class="title">{{solutions[7].title}}</div>
                    <div class="content">{{solutions[7].content}}</div>
                </div>
            </el-col>
        </el-row>
       </div>
    </div>
   </template>
   
<script>
export default {
  data () {
    return {
        solutions: [
                    {
                        img: require('../assets/business/business_1.png'),
                        title: "商品管理",
                        content: "支持商品的基础信息管理，库存数量管理"
                    },
                    {
                        img: require('../assets/business/business_2.png'),
                        title: "交易管理",
                        content: "后台可对用户的订单状态实时查看、管理"
                    }, {
                        img: require('../assets/business/business_3.png'),
                        title: "展现管理",
                        content: "支持对前端的banner、排行榜、推荐区商品进行实时更新"
                    },
                    {
                        img: require('../assets/business/business_4.png'),
                        title: "营销管理",
                        content: "针对特定商品范围的营销活动管理"
                    },  {
                        img: require('../assets/business/business_5.png'),
                        title: "仓库管理",
                        content: "支持自营商品的出库、入库，仓库中各商品库存数量管理"
                    },  {
                        img: require('../assets/business/business_6.png'),
                        title: "纸电联动",
                        content: "纸书和电子书自动进行关联，相互促进"
                    },  {
                        img: require('../assets/business/business_7.png'),
                        title: "丰富前端表现",
                        content: "支持APP、H5多前端业务表现形式"
                    },  {
                        img: require('../assets/business/business_8.png'),
                        title: "统计报表",
                        content: "支持用户、商品、订单多维度可视化报表"
                    },
                   
                ],
    }
  },
  computed: {
  },
  mounted() {
  },
}
   
</script>
   <style scoped lang="scss">
   .e-commerce-wrap{
       .top-wrap{
           height: 450px;
           background: #466dff;
           display: flex;
           align-items: center;
           justify-content: center;
           .text-wrap{
               width: 450px;
               // background: orange;
               margin-right: 50px;
               color: white;
               .title{
                   font-size: 24px;
                   margin-bottom: 20px;
               }
               .sub-title{
                   font-size: 16px;
               }
           }
       }
       .business-title{
        text-align: center;
        // background: red;
        height: 40px;
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 30px;
        font-weight: 600;
       }
       .business-list-wrap{
        width:70%;
        margin: 20px auto;
            .solu_img_border {
                margin-top: 15px;
                width: 80px;
                height: 80px
            }
            .border_img_parent{
                // border: 1px solid red;
                display: flex;
                justify-content: center;
                // margin: 20px auto;
            }
        .title{
            text-align: center;
            font-size: 20px;
            color: #363636;
            margin-bottom: 10px;
        }   
        .content{
            text-align: center;
            font-size: 16px;
            color: #97A1AB;
            margin-bottom: 20px;
            width: 80%;
            margin: 20px auto;
        } 
       }
   }
   </style>
   